import type { RouteRecordRaw } from 'vue-router'

const Placeholder = () => import('@/views/PlaceholderView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/home/HomeView.vue'),
        meta: { title: '首页', requiresAuth: false },
      },
      {
        path: 'topics/:id(\\d+)',
        name: 'topic-detail',
        component: () => import('@/views/topic/TopicDetailView.vue'),
        meta: { title: '帖子详情', requiresAuth: false },
      },
      {
        path: 'topics/:id(\\d+)/edit',
        name: 'topic-edit',
        component: () => import('@/views/topic/publish/TopicEditView.vue'),
        meta: { title: '编辑帖子', requiresAuth: true },
      },
      {
        path: 'publish/question',
        name: 'publish-question',
        component: () => import('@/views/topic/publish/PublishQuestionView.vue'),
        meta: { title: '发起提问', requiresAuth: true },
      },
      {
        path: 'publish/article',
        name: 'publish-article',
        component: () => import('@/views/topic/publish/PublishArticleView.vue'),
        meta: { title: '发布文章', requiresAuth: true },
      },
      {
        path: 'me',
        component: () => import('@/views/profile/ProfileLayout.vue'),
        meta: { title: '个人中心', requiresAuth: true },
        children: [
          {
            path: '',
            name: 'profile-overview',
            component: () => import('@/views/profile/ProfileOverview.vue'),
            meta: { title: '个人中心' },
          },
          {
            path: 'topics',
            name: 'profile-topics',
            component: () => import('@/views/profile/MyTopics.vue'),
            meta: { title: '我的发布' },
          },
          {
            path: 'collections',
            name: 'profile-collections',
            component: () => import('@/views/profile/MyCollections.vue'),
            meta: { title: '我的收藏' },
          },
          {
            path: 'points',
            name: 'profile-points',
            component: () => import('@/views/profile/MyPoints.vue'),
            meta: { title: '积分流水' },
          },
          {
            path: 'wallet',
            name: 'profile-wallet',
            component: () => import('@/views/profile/MyWallet.vue'),
            meta: { title: '我的钱包' },
          },
          {
            path: 'ptrade',
            name: 'profile-ptrade',
            component: () => import('@/views/profile/MyPtrade.vue'),
            meta: { title: '我的 PTrade' },
          },
          {
            path: 'edit',
            name: 'profile-edit',
            component: () => import('@/views/profile/ProfileEdit.vue'),
            meta: { title: '编辑资料' },
          },
          {
            path: 'messages',
            name: 'profile-messages',
            component: () => import('@/views/profile/MyMessages.vue'),
            meta: { title: '消息中心' },
          },
          {
            path: 'columns',
            name: 'profile-columns',
            component: () => import('@/views/profile/MyColumns.vue'),
            meta: { title: '我的专栏' },
          },
        ],
      },

      // ============ 占位页（功能未开发） ============
      { path: 'questions', name: 'questions', component: () => import('@/views/questions/QuestionsView.vue'), meta: { title: '问答专区' } },
      { path: 'articles', name: 'articles', component: () => import('@/views/articles/ArticlesView.vue'), meta: { title: '文章专区' } },
      { path: 'search', name: 'search', component: () => import('@/views/search/SearchView.vue'), meta: { title: '搜索' } },
      { path: 'users/:id(\\d+)', name: 'user-home', component: () => import('@/views/user/UserHomeView.vue'), meta: { title: '用户主页', requiresAuth: false } },
      { path: 'columns', name: 'columns', component: () => import('@/views/columns/ColumnsView.vue'), meta: { title: '专栏' } },
      { path: 'columns/:id(\\d+)', name: 'column-detail', component: () => import('@/views/columns/ColumnDetailView.vue'), meta: { title: '专栏详情' } },
      { path: 'experts', name: 'experts', component: () => import('@/views/experts/ExpertsView.vue'), meta: { title: '大咖' } },
      { path: 'academy', name: 'academy', component: () => import('@/views/academy/AcademyView.vue'), meta: { title: '量化学院' } },
      { path: 'topics-hub', name: 'topics-hub', component: Placeholder, meta: { title: '话题' } },
      { path: 'votes', name: 'votes', component: Placeholder, meta: { title: '投票' } },
      { path: 'ptrade', name: 'ptrade', component: () => import('@/views/ptrade/PtradeDownloadView.vue'), meta: { title: 'PTrade 下载' } },
      // PTrade 会员（Round 24）：平台自营付费产品，导航「PTrade ▾」下拉的第二项
      { path: 'ptrade-member', name: 'ptrade-member', component: () => import('@/views/ptrade/PtradeMemberView.vue'), meta: { title: 'PTrade 会员' } },
      // 新手四步的第 1 步。不复用 /ptrade（下载页地址已经分享出去了）
      { path: 'ptrade-intro', name: 'ptrade-intro', component: () => import('@/views/ptrade/PtradeIntroView.vue'), meta: { title: '什么是 PTrade' } },
      // 新手四步的第 3 步
      { path: 'ptrade-strategy', name: 'ptrade-strategy', component: () => import('@/views/ptrade/PtradeStrategyView.vue'), meta: { title: '跑通第一个策略' } },
      // 新手四步的第 4 步
      { path: 'ptrade-live', name: 'ptrade-live', component: () => import('@/views/ptrade/PtradeLiveView.vue'), meta: { title: '迈向实盘' } },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { title: '登录', requiresAuth: false },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: { title: '注册', requiresAuth: false },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: { title: '找回密码', requiresAuth: false },
  },
  {
    // 邮件里的重置链接指向这里，带 ?token=xxx。
    // 路径必须跟后端 PasswordResetServiceImpl.buildResetLink 拼的一致。
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/auth/ResetPasswordView.vue'),
    meta: { title: '设置新密码', requiresAuth: false },
  },
  {
    // 微信授权回调落地页（Round 18）。
    //
    // 链路：微信 302 → 后端 /api/web/auth/wechat/callback → 302 到这里，
    // 带 ?sceneToken=xxx（失败时另带 &error=xxx）。
    //
    // ⚠️ 路径必须跟后端 app.wechat-oauth.frontend-callback-url 配的一致。
    //    改这里必须同时改 application.yml，否则用户扫码后会落到 404 页。
    //
    // 这个页面是在【手机微信内置浏览器】里显示的 —— 网页授权只能在微信内工作。
    path: '/wechat-login',
    name: 'wechat-login',
    component: () => import('@/views/auth/WechatCallbackView.vue'),
    meta: { title: '微信登录', requiresAuth: false },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { title: '页面不存在', requiresAuth: false },
  },
]

export default routes
